import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/preregistro',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReportePreregistroPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Pre - registro</PageTitle>
      <View />
    </>
  );
};

export { ReportePreregistroPage };
